﻿import * as React from 'react';
import { NavLink } from "react-router-dom";

export default function EventsLauncher() {

    return (
        <div className="launcher-container">
            <h1 className="main-title">TASKS AND EVENTS</h1>

            <div className="card-container">

                <NavLink className="pw-card-link" to="/events-log">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">event</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">EVENTS LOG</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/tasks-management">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">list_alt</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">TASK TYPES</div>
                        </div>
                    </div>
                </NavLink>
            
                <NavLink className="pw-card-link" to="/tasks">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">calendar_clock</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">TASKS</div>
                        </div>
                    </div>
                </NavLink>
            </div>


        </div>
    );



}